
import { defineComponent, nextTick, onMounted, ref, watch } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Rating from "../Rating.vue";
import axios from "axios";
import { useRoute } from "vue-router";
const video = ref();
const canvas = ref();
const captures = ref({});
const isCameraOpen = ref(false);
const listData = ref();
const limit = ref(6);
const page = ref(0);
const orderBy = ref(1);
const categories = ref([]);
const totalPage = ref(0);
const listCertificate = ref();
const dialogSurvey = ref(false);
const surveyCourseId = ref(null);
const surveyOptions = ref([
  { emoji: "😆", label: "มากที่สุด", value: 5 },
  { emoji: "😊", label: "มาก", value: 4 },
  { emoji: "😐", label: "ปานกลาง", value: 3 },
  { emoji: "😞", label: "น้อย", value: 2 },
  { emoji: "😢", label: "น้อยที่สุด", value: 1 },
]);
const surveyData = ref({
  q1: null,
  q2: null,
  q3: null,
  q4: null,
  q5: null,
  suggestion: "",
});
const filterForm = ref({
  recommend: "",
  category: "",
  status: "",
  sortBy: "3",
  search: "",
  hashtag: "",
});
export default defineComponent({
  name: "voluntary",
  components: {
    Rating,
  },
  data() {
    return {
      categoryList: [],
      imageUrl: process.env.VUE_APP_IMG_URL,
    };
  },
  setup() {
    /* eslint-disable */
    const route = useRoute();
    onMounted(() => {
      if (route.query.recommend) {
        filterForm.value.recommend = route.query.recommend + "";
      }
      if (route.query.hashtag) {
        filterForm.value.hashtag = route.query.hashtag + "";
      }
      getDataList();
    });
    watch(
      () => route.path,
      () => {
        nextTick(() => {
          if (route.query.recommend) {
            filterForm.value.recommend = route.query.recommend + "";
          }
          if (route.query.hashtag) {
            filterForm.value.hashtag = route.query.hashtag + "";
          }
          getDataList();
        });
      },
    );
    const getDataList = () => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getCourse?sizeContents=" +
            limit.value +
            "&page=" +
            page.value +
            "&orderBy=" +
            orderBy.value +
            "&sort=" +
            filterForm.value.sortBy +
            "&category=" +
            filterForm.value.category +
            "&registerStatus=" +
            filterForm.value.status +
            "&keyWord=" +
            filterForm.value.search +
            "&recommend=" +
            filterForm.value.recommend +
            "&hashtag=" +
            filterForm.value.hashtag +
            "&flgGeneral=1",
          {
            headers: {
              token: localStorage.getItem("id_token")
                ? localStorage.getItem("id_token")
                : localStorage.getItem("tokenGuest"),
            },
          },
        )
        .then((response) => {
          // console.log(response);
          listData.value = response.data.data.content;
          listData.value["totalElements"] = response.data.data.totalElements;
          totalPage.value = response.data.data.totalPages;
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const changePage = (pageEvent) => {
      // console.log(pageEvent);
      page.value = pageEvent - 1;
      getDataList();
    };
    const backPage = () => {
      page.value = page.value - 1;
      getDataList();
    };
    const nextPage = () => {
      page.value = page.value + 1;
      getDataList();
    };
    const searchData = () => {
      getDataList();
    };
    const getCertificateId = async (id) => {
      // เปิดหน้าต่างทันทีขณะยังอยู่ใน user gesture ป้องกัน popup blocker บน iOS Safari
      const certWindow = window.open("", "_blank");
      let checkSurvey = await axios.get(
        process.env.VUE_APP_API_URL + "/checkCertApproveSurvey",
        {
          headers: { token: localStorage.getItem("id_token") },
        },
      );
      if (checkSurvey.data.code == 400) {
        if (certWindow) certWindow.close();
        dialogSurvey.value = true;
        surveyCourseId.value = id;
        surveyData.value = {
          q1: null,
          q2: null,
          q3: null,
          q4: null,
          q5: null,
          suggestion: "",
        };
      } else {
        proceedDownloadCertificate(id, certWindow);
      }
    };
    const proceedDownloadCertificate = async (id, certWindow: any = null) => {
      const certificate = await axios.get(
        process.env.VUE_APP_API_URL +
          "/getCourseRegister?courseId=" +
          id +
          "&userId=" +
          localStorage.getItem("u_id"),
        {
          headers: { token: localStorage.getItem("id_token") },
        },
      );
      listCertificate.value = certificate.data.data.content[0];
      downloadCertificate(listCertificate.value.id, certWindow);
    };
    const submitSurvey = async () => {
      // เปิดหน้าต่างทันทีขณะยังอยู่ใน user gesture ป้องกัน popup blocker บน iOS Safari
      const certWindow = window.open("", "_blank");
      let fromData = new FormData();
      fromData.append("q1", surveyData.value.q1 + "");
      fromData.append("q2", surveyData.value.q2 + "");
      fromData.append("q3", surveyData.value.q3 + "");
      fromData.append("q4", surveyData.value.q4 + "");
      fromData.append("q5", surveyData.value.q5 + "");
      fromData.append("q6", surveyData.value.suggestion);
      await axios.post(
        process.env.VUE_APP_API_URL + "/addEditCertApproveSurvey",
        fromData,
        {
          headers: {
            token: localStorage.getItem("id_token"),
            "Content-Type": "multipart/form-data",
          },
        },
      );
      dialogSurvey.value = false;
      proceedDownloadCertificate(surveyCourseId.value, certWindow);
    };
  const downloadCertificate = async (id, certWindow: any = null) => {
      if (!certWindow) {
        certWindow = window.open("", "_blank");
      }
      Swal.fire({
        title: "กำลังดาวน์โหลดใบประกาศนียบัตร",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/downloadCertificateCourse?courseRegisterId=" +
            id,
          {
            headers: { token: localStorage.getItem("id_token") },
            responseType: "blob", // กำหนดให้รับข้อมูลเป็น Blob
          },
        )
        .then(async (res) => {
          console.log(res);
          
          if (res.data) {
            const contentDisposition = res.headers["content-disposition"];
            const fileName = contentDisposition
              ? contentDisposition.split("filename=")[1]
              : "certificate.pdf";

            // ตรวจสอบเนื้อหาในกรณีเกิดข้อผิดพลาด
            if (res.data.type === "application/json") {
              const text = await res.data.text();
              const errorData = JSON.parse(text);
              console.error("Error downloading PDF:", errorData.message);
              if (certWindow) certWindow.close();
              Swal.fire({
                title: "ดาวน์โหลดไฟล์ไม่สำเร็จ",
                text: "กรุณาลองใหม่อีกครั้ง",
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "ตกลง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-primary",
                },
              });
              return;
            }

            // สร้าง Blob URL แล้วนำหน้าต่างที่เปิดไว้ตั้งแต่ตอน user gesture ไปที่ URL นั้น
            const url = window.URL.createObjectURL(
              new Blob([res.data], { type: "application/pdf" }),
            );
            if (certWindow) {
              certWindow.location.href = url;
            } else {
              window.open(url, "_blank");
            }
            Swal.close();
          } else {
            if (certWindow) certWindow.close();
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: res.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          if (certWindow) certWindow.close();
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    const arabic_to_thai = (text) => {
      let data = text
        .replaceAll("1", "๑")
        .replaceAll("2", "๒")
        .replaceAll("3", "๓")
        .replaceAll("4", "๔")
        .replaceAll("5", "๕")
        .replaceAll("6", "๖")
        .replaceAll("7", "๗")
        .replaceAll("8", "๘")
        .replaceAll("9", "๙")
        .replaceAll("0", "๐");
      return data;
    };
    return {
      video,
      canvas,
      captures,
      isCameraOpen,
      getDataList,
      changePage,
      backPage,
      nextPage,
      listData,
      limit,
      page,
      orderBy,
      categories,
      totalPage,
      filterForm,
      searchData,
      getCertificateId,
      downloadCertificate,
      listCertificate,
      arabic_to_thai,
      dialogSurvey,
      surveyCourseId,
      surveyOptions,
      surveyData,
      submitSurvey,
    };
  },
  methods: {
    formatDate(date) {
      const event = new Date(date);
      let dateString =
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }) + "";
      return dateString;
    },
    removeStyle(html) {
      const regex = /(style=".+?")/gm;
      const str = html;
      const subst = ``;
      const result = str.replace(regex, subst);
      return result;
    },
    setAltImg(event) {
      event.target.src = "media/image-app/no-image.svg";
    },
    /* eslint-disable */
    renderCategory(list) {
      let data: any = [];
      for (const looplist of list) {
        data.push(looplist[0].data);
      }
      if (data.length > 0) {
        return data.join(",");
      } else {
        return "-";
      }
    },
    renderStatus(status) {
      if (status == 1 || status == 2) {
        return "<span style='color:#9999D3'>เรียนต่อ</span>";
      } else if (status == 3) {
        return "<span style='color:#31B67C'>เรียนจบ</span>";
      } else if (status == 4) {
        return "<span style='color:#FF7786'>ไม่ผ่านหลักสูตร</span>";
      } else if (status == 5) {
        return "<span style='color:#F2A17D'>หมดเวลาเรียน</span>";
      } else {
        return "-";
      }
    },
  },
  async mounted() {
    try {
      const category = await axios.get(
        process.env.VUE_APP_API_URL + "/category?categoryType=course",
        {
          headers: {
            token: localStorage.getItem("id_token")
              ? localStorage.getItem("id_token")
              : localStorage.getItem("tokenGuest"),
          },
        },
      );
      this.categoryList = category.data?.data;
    } catch (error) {
      // console.log(error);
    }
  },
});
